module.exports = __webpack_public_path__ + "img/entertainment.4d21b909.svg";